import {createAction, createAsyncAction} from "typesafe-actions"

// Models
import {Record, Signal} from "../../models"
import {EntityByKey, ResponseError} from "../../../../models"

export const fetchNextRecordAsync = createAsyncAction(
    "@@records/FETCH_NEXT",
    "@@records/FETCH_NEXT_SUCCESS",
    "@@records/FETCH_NEXT_FAILURE",
)<undefined, Record, ResponseError>();

export const fetchNextRecordByIdAsync = createAsyncAction(
    "@@records/FETCH_NEXT_BY_ID",
    "@@records/FETCH_NEXT_BY_ID_SUCCESS",
    "@@records/FETCH_NEXT_BY_ID_FAILURE",
)<string, Record, ResponseError>();

export const fetchInProgressNextRecordByIdAsync = createAsyncAction(
    "@@records/FETCH_NEXT_INPROGRESS_BY_ID",
    "@@records/FETCH_NEXT_INPROGRESS_BY_ID_SUCCESS",
    "@@records/FETCH_NEXT_INPROGRESS_BY_ID_FAILURE",
)<string, Record, ResponseError>();

export const fetchRecordByIdAsync = createAsyncAction(
    "@@records/FETCH_BY_ID",
    "@@records/FETCH_BY_ID_SUCCESS",
    "@@records/FETCH_BY_ID_FAILURE",
)<string, Record, ResponseError>();

export const fetchRecordSignalAsync = createAsyncAction(
    "@@records/FETCH_SIGNAL",
    "@@records/FETCH_SIGNAL_SUCCESS",
    "@@records/FETCH_SIGNAL_FAILURE",
)<string, EntityByKey<Signal>, unknown>();

export const approveRecordAsync = createAsyncAction(
    "@@records/APPROVE",
    "@@records/APPROVE_SUCCESS",
    "@@records/APPROVE_FAILURE",
)<string, undefined, unknown>();

export const updateRecordConclusionAsync = createAsyncAction(
    "@@records/UPDATE_CONCLUSION",
    "@@records/UPDATE_CONCLUSION_SUCCESS",
    "@@records/UPDATE_CONCLUSION_FAILURE",
)<string, Record["conclusion"], unknown>();

export const updateRecordInterpretationsAsync = createAsyncAction(
  "@@records/UPDATE_INTERPRETATIONS",
  "@@records/UPDATE_INTERPRETATIONS_SUCCESS",
  "@@records/UPDATE_INTERPRETATIONS_FAILURE",
)<string, Record["interpretation"], unknown>();

export const updateRecordParametersAsync = createAsyncAction(
    "@@records/UPDATE_PARAMETERS",
    "@@records/UPDATE_PARAMETERS_SUCCESS",
    "@@records/UPDATE_PARAMETERS_FAILURE",
)<Record["commonParameters"], Record["commonParameters"], unknown>();

export const fetchPDFRecordAsync = createAsyncAction(
    "@@records/FETCH_PDF",
    "@@records/FETCH_PDF_SUCCESS",
    "@@records/FETCH_PDF_FAILURE",
)<string, any, ResponseError>();

export const setReceiveNext = createAction("@@records/SET_RECEIVE_NEXT")<boolean>();
export const setApproveDialogActive = createAction("@@records/SET_APPROVE_DIALOG_ACTIVE")<boolean>();
//export const setToggleGraph = createAction("@@records/SET_TOGGLE_GRAPH")<boolean>();
export const clearCurrentRecord = createAction("@@records/CLEAR_CURRENT")();
export const sendUserInactive = createAction("@@records/SEND_USER_INACTIVE")();
export const toggleConclusionEditing = createAction("@@records/TOGGLE_CONCLUSION_EDITING")();
export const toggleParameterEditing = createAction("@@records/TOGGLE_PARAMETER_EDITING")();
export const recordConflict = createAction("@@records/RECORD_CONFLICT")();
